import { Box, Button } from '@mui/material'
import Title from 'components/title/Title'
import { Link } from 'react-router-dom'

export default function BenchmarkCreatePage() {
  return (
    <Box
      sx={{
        display: 'block',
        textAlign: 'left',
        maxWidth: '887px',
        margin: '89px auto 0 auto',
        padding: '0 20px',
      }}>
      <Title variant="h4" sx={{ pb: '33px' }}>
        Create Benchmark Report
      </Title>
      <Box>
        <Button component={Link} to="/benchmark/create/company" variant="contained">
          With Company Name
        </Button>
      </Box>
      <Box mt={2}>
        <Button component={Link} to="/benchmark/create/ipcr" variant="contained">
          With IPCR Codes
        </Button>
      </Box>
    </Box>
  )
}
